const React = require('react')
const { UncontrolledTooltip } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

const CopyButton = props => {
    const { id, data, text } = props

    const { network } = useNetworkConfig()

    return (
        <>
            <div
                id={id}
                onClick={() => {
                    navigator.clipboard.writeText(data)
                    const iconElement = document.querySelector(`#${id} i`)
                    const tooltipElement = document.querySelector(`#tooltip-${data}`)

                    if (iconElement && tooltipElement) {
                        iconElement.classList.remove('fa-copy')
                        iconElement.classList.add('fa-check')
                        tooltipElement.innerText = 'Copied!'

                        setTimeout(() => {
                            iconElement.classList.remove('fa-check')
                            iconElement.classList.add('fa-copy')
                            tooltipElement.innerText = `${text}`
                        }, 500)
                    }
                }}
                className={`${network.name}-icon-wrapper`}
                style={{
                    marginLeft: '4px',
                    cursor: 'pointer',
                    display: 'inline-block'
                }}
            >
                <i className='fas fa-copy' />
            </div>
            <UncontrolledTooltip placement='top' target={`${id}`}>
                <span id={`tooltip-${data}`}>{text}</span>
            </UncontrolledTooltip>
        </>
    )
}

module.exports = { CopyButton }
